export default __webpack_public_path__ + "static/media/rastech-logo.70d010a7.png";